const subscriptionConstants = {
	// List operations
	SUBSCRIPTIONS_LIST_REQUEST: "SUBSCRIPTIONS_LIST_REQUEST",
	SUBSCRIPTIONS_LIST_SUCCESS: "SUBSCRIPTIONS_LIST_SUCCESS",
	SUBSCRIPTIONS_LIST_FAILURE: "SUBSCRIPTIONS_LIST_FAILURE",

	// Create operations
	SUBSCRIPTIONS_CREATE_REQUEST: "SUBSCRIPTIONS_CREATE_REQUEST",
	SUBSCRIPTIONS_CREATE_SUCCESS: "SUBSCRIPTIONS_CREATE_SUCCESS",
	SUBSCRIPTIONS_CREATE_FAILURE: "SUBSCRIPTIONS_CREATE_FAILURE",

	// Generic request feedback
	SUBSCRIPTIONS_SET_SUCCESS_MESSAGE: "SUBSCRIPTIONS_SET_SUCCESS_MESSAGE",
	SUBSCRIPTIONS_ACTION_SUCCESS: "SUBSCRIPTIONS_ACTION_SUCCESS",
	SUBSCRIPTIONS_ACTION_FAILURE: "SUBSCRIPTIONS_ACTION_FAILURE",
	SUBSCRIPTIONS_CLEAR_REQUEST_STATE: "SUBSCRIPTIONS_CLEAR_REQUEST_STATE",

	// Update operations (placeholder for future implementation)
	SUBSCRIPTIONS_UPDATE_REQUEST: "SUBSCRIPTIONS_UPDATE_REQUEST",
	SUBSCRIPTIONS_UPDATE_SUCCESS: "SUBSCRIPTIONS_UPDATE_SUCCESS",
	SUBSCRIPTIONS_UPDATE_FAILURE: "SUBSCRIPTIONS_UPDATE_FAILURE",

	// Deactivate operations (placeholder for future implementation)
	SUBSCRIPTIONS_DEACTIVATE_REQUEST: "SUBSCRIPTIONS_DEACTIVATE_REQUEST",
	SUBSCRIPTIONS_DEACTIVATE_SUCCESS: "SUBSCRIPTIONS_DEACTIVATE_SUCCESS",
	SUBSCRIPTIONS_DEACTIVATE_FAILURE: "SUBSCRIPTIONS_DEACTIVATE_FAILURE",

	// Archive operations (placeholder for future implementation)
	SUBSCRIPTIONS_ARCHIVE_REQUEST: "SUBSCRIPTIONS_ARCHIVE_REQUEST",
	SUBSCRIPTIONS_ARCHIVE_SUCCESS: "SUBSCRIPTIONS_ARCHIVE_SUCCESS",
	SUBSCRIPTIONS_ARCHIVE_FAILURE: "SUBSCRIPTIONS_ARCHIVE_FAILURE",

	// Delete operations (placeholder for future implementation)
	SUBSCRIPTIONS_DELETE_REQUEST: "SUBSCRIPTIONS_DELETE_REQUEST",
	SUBSCRIPTIONS_DELETE_SUCCESS: "SUBSCRIPTIONS_DELETE_SUCCESS",
	SUBSCRIPTIONS_DELETE_FAILURE: "SUBSCRIPTIONS_DELETE_FAILURE",

	// Filters and state
	SUBSCRIPTIONS_FILTERS_UPDATE: "SUBSCRIPTIONS_FILTERS_UPDATE",
	SUBSCRIPTIONS_CLEAR_FILTERS: "SUBSCRIPTIONS_CLEAR_FILTERS",
	SUBSCRIPTIONS_SET_CURRENT: "SUBSCRIPTIONS_SET_CURRENT",
	SUBSCRIPTIONS_CLEAR_CURRENT: "SUBSCRIPTIONS_CLEAR_CURRENT",

	// Metadata operations
	SUBSCRIPTIONS_METADATA_REQUEST: "SUBSCRIPTIONS_METADATA_REQUEST",
	SUBSCRIPTIONS_METADATA_SUCCESS: "SUBSCRIPTIONS_METADATA_SUCCESS",
	SUBSCRIPTIONS_METADATA_FAILURE: "SUBSCRIPTIONS_METADATA_FAILURE",

	// Stats operations
	SUBSCRIPTIONS_STATS_REQUEST: "SUBSCRIPTIONS_STATS_REQUEST",
	SUBSCRIPTIONS_STATS_SUCCESS: "SUBSCRIPTIONS_STATS_SUCCESS",
	SUBSCRIPTIONS_STATS_FAILURE: "SUBSCRIPTIONS_STATS_FAILURE",

	// Request management
	SUBSCRIPTIONS_RESET_STATUS: "SUBSCRIPTIONS_RESET_STATUS",
	SUBSCRIPTIONS_REQUEST_DONE: "SUBSCRIPTIONS_REQUEST_DONE",

	// Query parameters
	SET_SUBSCRIPTION_QUERY_PARAMETER: "SET_SUBSCRIPTION_QUERY_PARAMETER",
	CLEAR_SUBSCRIPTION_QUERY_PARAMETER: "CLEAR_SUBSCRIPTION_QUERY_PARAMETER",
};

export default subscriptionConstants;
